import { runDemo } from "../shared/demoRunner";
import { createPostProcessRefractionScene } from "./scene";

runDemo({ createScene: createPostProcessRefractionScene });
